module.exports = __webpack_public_path__ + "static/media/memos_note11.1cb67ba2.jpg";